import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

function CustomButton({
  block,
  size,
  color,
  text,
  onClick,
  disabled,
  className
}) {
  return (
    <Button
      className={className}
      block={block}
      size={size}
      color={color}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
}

CustomButton.propTypes = {
  block: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default CustomButton;
